import type { FindingResponse } from '../../types';

/**
 * True when a finding needs a person's judgment rather than an automatable fix —
 * i.e. it carries a `human_review` (a scoped question) instead of an applicable
 * `changeset` (SC-2291). The two are mutually exclusive on the wire: when no op
 * can resolve a finding, the BE emits a `human_review` in its place.
 *
 * For these there's no proposed value to apply — the rationale *is* the
 * explanation of what to look at — so FindingCard renders the rationale inline
 * (not behind a disclosure) and the action surfaces show Dismiss only.
 */
export function isFlagForReview(finding: FindingResponse): boolean {
  return finding.human_review != null;
}
